module.exports = __webpack_public_path__ + "static/algerie-858ccfef589ed9b46f4ab1cf0da74d3d.jpg";